import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const AboutSection = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 md:mb-6">
              {t('about.title')}
            </h2>
            <p className="text-lg md:text-xl text-gray-600">
              {t('about.subtitle')}
            </p>
          </div>

          <div className="space-y-8 md:space-y-10">
            <div className="bg-gray-50 rounded-2xl p-6 md:p-8">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-10 h-10 rounded-xl bg-[#0025cc]/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="History" size={20} color="#0025cc" />
                </div>
                <div>
                  <h3 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
                    {t('about.originsTitle')}
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    {t('about.originsDesc')}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-6 md:p-8">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-10 h-10 rounded-xl bg-[#0025cc]/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="Lightbulb" size={20} color="#0025cc" />
                </div>
                <div>
                  <h3 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3">
                    {t('about.breakingPointTitle')}
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    {t('about.breakingPointDesc1')}
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    {t('about.breakingPointDesc2')}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-[#0025cc] text-white rounded-2xl p-6 md:p-8">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center flex-shrink-0">
                  <Icon name="Target" size={20} color="#FFFFFF" />
                </div>
                <div>
                  <h3 className="text-xl md:text-2xl font-semibold mb-3">
                    {t('about.missionTitle')}
                  </h3>
                  <p className="text-white/90 leading-relaxed mb-4">
                    {t('about.missionDesc1')}
                  </p>
                  <p className="text-white/90 leading-relaxed">
                    {t('about.missionDesc2')}
                  </p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
              <div className="text-center">
                <div className="w-16 h-16 rounded-2xl bg-[#0025cc]/10 flex items-center justify-center mx-auto mb-4">
                  <Icon name="Users" size={28} color="#0025cc" />
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2">
                  {t('about.forCandidatesTitle')}
                </h4>
                <p className="text-gray-600 text-sm">
                  {t('about.forCandidatesDesc')}
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 rounded-2xl bg-[#0025cc]/10 flex items-center justify-center mx-auto mb-4">
                  <Icon name="Building2" size={28} color="#0025cc" />
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2">
                  {t('about.forCompaniesTitle')}
                </h4>
                <p className="text-gray-600 text-sm">
                  {t('about.forCompaniesDesc')}
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 rounded-2xl bg-[#0025cc]/10 flex items-center justify-center mx-auto mb-4">
                  <Icon name="Heart" size={28} color="#0025cc" />
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2">
                  {t('about.ourPromiseTitle')}
                </h4>
                <p className="text-gray-600 text-sm">
                  {t('about.ourPromiseDesc')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;